export default __webpack_public_path__ + "static/corporate-mobility-ae581b0c1cce6e51fbfb821757f9e83a.png";